// @flow
import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import { Select, Flex } from '../'
import { ControllerError } from './'

export type SelectOption = {
  label: string,
  value: any
}

export type SelectOptionGroup = {
  label: string,
  value: any,
  options: Array<{ label: string, value: any }>
}

type SelectControllerProps = {
  name: string,
  options: Array<SelectOption | SelectOptionGroup>,
  label?: string,
  rules?: any,
  defaultValue?: any,
  transformValue?: (value: any) => any,
  transformOutput?: (value: any) => any,
  wrapperProps?: {
    [key: string]: any
  }
}

const flatOptions = (options: $PropertyType<SelectControllerProps, 'options'>): SelectOption[] =>
  //$FlowFixMe
  options.map(option => (Array.isArray(option.options) ? option.options : option)).flat()

const SelectController = ({
  name,
  label,
  defaultValue,
  transformValue,
  transformOutput,
  options,
  rules,
  wrapperProps,
  ...props
}: SelectControllerProps) => {
  const { errors } = useFormContext()
  return (
    <Flex column {...wrapperProps}>
      <Controller
        defaultValue={defaultValue}
        name={name}
        render={({ field: { onChange, value } }) => {
          return (
            <Select
              id={`${name}-select`}
              label={label}
              options={options}
              value={typeof transformValue === 'function' ? transformValue(value) : value}
              valueFunc={selectValue => {
                if (selectValue === undefined) {
                  return null
                }
                if (Array.isArray(selectValue)) {
                  const destructuredValues = selectValue.map(property => {
                    if (typeof property === 'object') {
                      return property
                    }
                    return flatOptions(options).find(option => option.value === property) || null
                  })

                  return destructuredValues
                }
                if (typeof selectValue === 'object') {
                  return selectValue
                }
                return flatOptions(options).find(option => option.value === selectValue) || null
              }}
              onChange={selectValue => {
                const transformOutputFunction = value => {
                  if (typeof transformOutput === 'function') {
                    return transformOutput(value)
                  }
                  return value
                }
                if (Array.isArray(selectValue)) {
                  if (!selectValue.length) {
                    // Empty array is not allowed as empty value
                    return onChange(transformOutputFunction(null))
                  }
                  return onChange(transformOutputFunction(selectValue.map(d => d.value)))
                } else {
                  return onChange(transformOutputFunction(selectValue && selectValue.value))
                }
              }}
              {...props}
            />
          )
        }}
        rules={rules}
      />
      <ControllerError errors={errors} name={name} />
    </Flex>
  )
}

export { SelectController }
